<template>
    <Layout class="layout">
        <Headers></Headers>
        <Layout>
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout class="zc-main">
                <Content class="zc-body" :style="{height:($store.state.tableHight - 105) + 'px'}">
                    <Row :gutter="16" style="display: none">
                        <Col span="4">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.orderCount}}
                                    </div>
                                    <div class="order-count-small text-999">
                                        <span>今日新增</span>
                                        <em class="text-danger">+{{basic.orderTodayCount}}</em>
                                    </div>
                                </div>
                                <div class="name">订单统计</div>
                                <Icon type="ios-cafe" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="4">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.hospitalCount}}
                                    </div>
                                    <div class="order-count-small text-999">
                                        <span>今日新增</span>
                                        <em class="text-danger">+{{basic.hospitalTodayCount}}</em>
                                    </div>
                                </div>
                                <div class="name">机构统计</div>
                                <Icon type="md-contacts" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="4">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.contractCount}}
                                    </div>
                                    <div class="order-count-small text-999">
                                        <span>今日新增</span>
                                        <em class="text-danger">+{{basic.contractTodayCount}}</em>
                                    </div>
                                </div>
                                <div class="name">合同统计</div>
                                <Icon type="ios-photos" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="4">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.expressCount}}
                                    </div>
                                    <div class="order-count-small text-999">
                                        <span>今日新增</span>
                                        <em class="text-danger">+{{basic.expressTodayCount}}</em>
                                    </div>
                                </div>
                                <div class="name">物流点统计</div>
                                <Icon type="ios-rose" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="4">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.driverCount}}
                                    </div>
                                    <div class="order-count-small text-999">
                                        <span>今日新增</span>
                                        <em class="text-danger">+{{basic.driverTodayCount}}</em>
                                    </div>
                                </div>
                                <div class="name">运输员统计</div>
                                <Icon type="md-thumbs-up" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="4">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.carCount}}
                                    </div>
                                    <div class="order-count-small text-999">
                                        <span>今日新增</span>
                                        <em class="text-danger">+{{basic.carTodayCount}}</em>
                                    </div>
                                </div>
                                <div class="name">车辆统计</div>
                                <Icon type="md-car" size="26" class="icons" />
                            </div>
                        </Col>
                    </Row>
                    <Row style="display: none">
                        <Col span="24">
                            <Card :bordered="false" class="rx-index-card" >
                                <div slot="title" class="text-primary"><Icon type="md-stats" size="16"  /> 近7日资金统计</div>
                                <span slot="extra">
                                   <Icon type="md-calendar" /> 2023-07-21 ~ 2023-07-28
                                </span>
                                <div>
                                    统计图
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Content>
            </Layout>
        </Layout>
    </Layout>
</template>

<script>
import '@/assets/admin/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";

export default {
  name: 'HomeIndex',
    components: {
        Headers, Side
    },
  data () {
    return {
        isCollapsed: false,
        basic: [],
    }
  },
    created(){
        // this.getStatic();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {
        rotateIcon () {
            return [
                'menu-icon',
                this.isCollapsed ? 'rotate-icon' : ''
            ];
        },
        menuitemClasses () {
            return [
                'menu-item',
                this.isCollapsed ? 'collapsed-menu' : ''
            ]
        }
    },
    methods: {
        getStatic(){
            let that = this;
            that.$axios.get('/admin/index/getStatic')
                .then(function (e) {
                    if(e.code ==0) {
                        that.basic = e.data;
                    }else{
                        that.$Message.error({ background: true,duration:3, content:e.msg});
                    }
                })
                .catch(function (e) {
                    that.$Message.error({ background: true,duration:3, content:'请求发送失败'});
                });
        },
        collapsedSider () {
            this.$refs.side1.toggleCollapse();
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
    .rx-index-box {
        width: 100%;
        position: relative;
        border: 1px solid #f6f6f6;
        background: #f6f6f6;
        border-radius: 5px;
        padding: 25px 10px;
        position: relative;
        box-shadow: 5px 5px 10px #EEE;
        cursor: pointer;
        .name {
            width: 100%;
            font-size: 15px;
            //font-weight: bold;
        }
        .box-line {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 15px;
            .order-count {
                font-size: 20px;
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .order-count-small {
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                em {
                    font-size: 16px;
                    padding-left: 10px;
                }
            }
        }
        .icons {
            position: absolute;
            bottom: 10px;
            right: 10px;
            color: rgba(40,130,255,0.1);
        }
    }
    .rx-index-card {
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/view/home/Index.vue